import React, { Suspense } from "react";
import ReactDOM from "react-dom";
// import "@babel/polyfill";
import App from "./App";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import history from "./utils/history";
import SnackbarProvider from "react-simple-snackbar";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import configureStore from "./configureStore";
import { PersistGate } from "redux-persist/integration/react";

import "./i18next";
import "./global-styles.scss";
import * as serviceWorker from "./serviceWorker";

// Create redux store with history
const initialState = {};
const { store, persistor } = configureStore(initialState, history);
// optional configuration
const options = {
  // you can also just use 'bottom center'
  position: positions.TOP_RIGHT,
  timeout: 2000,
  offset: "30px",
  // you can also just use 'scale'
  transition: transitions.SCALE,
};

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConnectedRouter history={history}>
          <SnackbarProvider position="top-right">
            <AlertProvider template={AlertTemplate} {...options}>
              <Suspense fallback="loading">
                <App />
              </Suspense>
            </AlertProvider>
          </SnackbarProvider>
        </ConnectedRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
